// pages/AllWriters.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../styles/allWriters.css';

const AllWriters = () => {
  const [writers, setWriters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  
  const writersPerPage = 10;

  useEffect(() => {
    const fetchWriters = async () => {
      try {
        const response = await axios.get('https://n8n.iniai.cloud/webhook/get-all-writers', {
          headers: {
            'x-api-key': 'auth_k_2f9a8b3c7d6e4f5g9h8i1j2k3l4m5n6',
            'Content-Type': 'application/json'
          }
        });
        
        setWriters(response.data);
      } catch (err) {
        console.error('Error fetching writers:', err);
        setError('Failed to load writers');
      } finally {
        setLoading(false);
      }
    };

    fetchWriters();
  }, []);

  // Filter writers based on search term
  const filteredWriters = writers.filter(writer => 
    writer.Name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Calculate pagination
  const totalPages = Math.ceil(filteredWriters.length / writersPerPage);
  const startIndex = (currentPage - 1) * writersPerPage;
  const displayedWriters = filteredWriters.slice(startIndex, startIndex + writersPerPage);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    window.scrollTo(0, 0);
  };

  if (loading) return <div className="loading-state">Loading writers...</div>;
  if (error) return <div className="error-state">{error}</div>;

  return (
    <div className="all-writers-container">
      <div className="writers-header">
        <h1>All Writers</h1>
        <div className="search-filter">
          <input
            type="text"
            placeholder="Search by name..."
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setCurrentPage(1);
            }}
            className="search-input"
          />
        </div>
      </div>

      <div className="writers-table">
        <table>
          <thead>
            <tr>
              <th className="name-col">Name</th>
              <th className="style-col">Writing Style</th>
              <th className="characteristics-col">Characteristics</th>
              <th className="expertise-col">Areas of Expertise</th>
              <th className="actions-col">Actions</th>
            </tr>
          </thead>
          <tbody>
            {displayedWriters.map(writer => (
              <tr key={writer.id}>
                <td>{writer.Name}</td>
                <td>{writer['Writing Style']}</td>
                <td>
                  {writer['Voice Characteristics'] && 
                    writer['Voice Characteristics'].map((char, idx) => (
                      <span key={idx} className="characteristic-tag">
                        {char}
                      </span>
                    ))
                  }
                </td>
                <td>
                  {writer['Areas of Expertise'] && 
                    writer['Areas of Expertise'].map((area, idx) => (
                      <span key={idx} className="expertise-tag">
                        {area}
                      </span>
                    ))
                  }
                </td>
                <td>
                  <button 
                    onClick={() => window.location.href = `/writinganalysisresult/${encodeURIComponent(writer.Name)}`}
                    className="view-button"
                  >
                    View
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {totalPages > 1 && (
        <div className="pagination">
          <div className="pagination-info">
            Showing {startIndex + 1} to {Math.min(startIndex + writersPerPage, filteredWriters.length)} of {filteredWriters.length} writers
          </div>
          <div className="pagination-controls">
            <button 
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="page-button"
            >
              Previous
            </button>
            {[...Array(totalPages)].map((_, index) => {
              // Only show 5 page buttons at a time
              if (
                index === 0 || 
                index === totalPages - 1 || 
                (index >= currentPage - 2 && index <= currentPage + 2)
              ) {
                return (
                  <button
                    key={index + 1}
                    onClick={() => handlePageChange(index + 1)}
                    className={`page-button ${currentPage === index + 1 ? 'active' : ''}`}
                  >
                    {index + 1}
                  </button>
                );
              } else if (
                (index === currentPage - 3 && currentPage > 3) || 
                (index === currentPage + 3 && currentPage < totalPages - 3)
              ) {
                return <span key={index} className="page-dots">...</span>;
              }
              return null;
            })}
            <button 
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="page-button"
            >
              Next
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AllWriters;